import { ConfigProfileView as Profile } from './Profile';

export default Profile;
